'use strict';Object.defineProperty(exports,'__esModule',{value:!0});var _LoggerSentry=require('./LoggerSentry/LoggerSentry'),_LoggerSentry2=_interopRequireDefault(_LoggerSentry);function _interopRequireDefault(a){return a&&a.__esModule?a:{default:a}}exports.default=_LoggerSentry2.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /builds/development/frontend/widgets/widgets/node_modules/@sm360/logger-sentry/dist/index.js
// module id = ../../node_modules/@sm360/logger-sentry/dist/index.js
// module chunks = widget-6.25.3